import { create } from 'zustand';

import type { PlayerTrack } from '@/music/types';

interface GenerationInfoStore {
  // 닫힘 애니메이션 동안 시트 내용을 유지하기 위해 close에서 track을 비우지 않음
  track: PlayerTrack | null;
  isOpen: boolean;
  open: (track: PlayerTrack) => void;
  close: () => void;
}

export const useGenerationInfoStore = create<GenerationInfoStore>((set) => ({
  track: null,
  isOpen: false,
  open: (track) => set({ track, isOpen: true }),
  close: () => set({ isOpen: false }),
}));
